import { constants } from './constants'

const loadInit = () => ({
  type: constants.LOAD_INIT,
})

const loadSucceeded = () => ({
  type: constants.LOAD_SUCCEEDED,
})

const loadFailed = error => ({
  type: constants.LOAD_FAILED,
  payload: error,
})

export const actions = {
  loadInit,
  loadSucceeded,
  loadFailed,
}
